export class Column {
  constructor(args) {
    this.selectable = args.selectable || false;
    this.hidden = args.hidden || false;

    this.field = args.field;
    this._fields = args.field?.split('.');
    this.title = args.title;
    this.width = args.width || 'auto';
    this.align = args.align || 'left';
    this.boColor = args.boColor || '';
    this.render = args.render;
    this.ascending = args.ascending;
    this.sortable = args.sortable || args.sortKey || typeof args.sort === 'function' ? true : false;
    if (this.sortable) {
      this.sortKey = args.sortKey || args.field;

      if (typeof args.sort === 'function') {
        this.sort = args.sort.bind(this);
      } else {
        this.sort = (itemA, itemB) => {
          var valueA = this.getValue(itemA);
          var valueB = this.getValue(itemB);
          if (typeof valueA === 'string') valueA = valueA.toLowerCase();
          else if (typeof valueA === 'boolean') valueA = valueA ? 1 : 2;
          else if (valueA === undefined) valueA = '';

          if (typeof valueB === 'string') valueB = valueB.toLowerCase();
          else if (typeof valueB === 'boolean') valueB = valueB ? 1 : 2;
          else if (valueB === undefined) valueB = '';

          // if the values are the same sort by the name to make sure the order are consistent when users switched between different columns for sorting
          if (valueA === valueB && this.field !== 'name') {
            valueA = itemA.name;
            valueB = itemB.name;
          }

          if (this.ascending) return valueA < valueB ? -1 : 1;
          return valueA > valueB ? -1 : 1;
        };
      }
    }

    if (!args.field) console.error('Column: [field] is require!');
    if (!args.title) console.error('Column: [title] is require!');
  }

  getValue(item) {
    let value;
    if (this._fields.length === 1) value = item[this.field];
    else {
      value = item;
      for (var i = 0, n = this._fields.length; i < n; ++i) {
        var prop = this._fields[i];
        if (prop in value) {
          value = value[prop];
        } else {
          break;
        }
      }
    }
    if (Array.isArray(value)) {
      if (value.length > 0) {
        if (typeof value[0] === 'string' || typeof value[0] === 'number') return value.join(', ');
      } else return '';
    }
    return value;
  }

  highlight(value, searchString) {
    if (typeof value !== 'string') value = value?.toString();
    if (!searchString || !value) return value;

    let rx = new RegExp(searchString, 'ig');
    let res = value.match(rx);

    if (res) return value.replace(rx, '<span class="highlight-text">$&</span>');
    return value;
  }
}
